export class AccountStateModel {
  account?: Account;
  showHiddenAdminFeatures: boolean;
}

export class Account {
  id: string;
  name: string;
  email: string;
  phone: string;
  originalEmail: string;
  identityProvider: string;
  identityProviders: string[];
  superAdmin: boolean;
  profileImageUrl: string;
  settings: AccountSettings;
  organizations: string[];
  token: string;
}

export class AccountSettings {
  expandParticipantsOnActivity: boolean;
}

export class PatchUserResponse {
  settings: UserSettings;
  email: string;
  originalEmail: string;
  phone: string;
}

export class UserSettings {
  expandParticipantsOnActivity: boolean;
}

// export class Toast {
//   type: string;
//   classname: string;
//   header: string;
//   text: string;
//   delay: number;
//   autohide: boolean;
// }
